import React, { useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import DownloadButton from "./PDFDownloader";
import { getHeaderClass } from "../../../utils/agGridHelpers";

const PanCardReportPage = ({ data, type }) => {
  const gridRef = useRef(null);

  const onGridReady = (params) => {
    gridRef.current = params.api;
  };

  const columnDefs = [
    { headerName: "S.NO", valueGetter: (params) => params.node.rowIndex + 1, width: 80, headerClass: getHeaderClass },
    { field: "panCardNo", headerName: "PAN Card No", filter: "agTextColumnFilter", width: 140, headerClass: getHeaderClass, valueGetter: (params) => params.data?.panCardNo || "-" },
    { field: "donorId", headerName: "Donor ID", filter: "agTextColumnFilter", width: 100, headerClass: getHeaderClass, valueGetter: (params) => params.data?.donorId || "-" },
    { field: "initial", headerName: "Initial", filter: "agTextColumnFilter", width: 90, headerClass: getHeaderClass, valueGetter: (params) => params.data?.initial || "-" },
    { field: "firstName", headerName: "Name", filter: "agTextColumnFilter", width: 140, headerClass: getHeaderClass, valueGetter: (params) => params.data?.firstName || "-" },
    { field: "address", headerName: "Address", filter: "agTextColumnFilter", width: 150, headerClass: getHeaderClass, valueGetter: (params) => params.data?.address || "-" },
    { field: "address1", headerName: "Address 1", filter: "agTextColumnFilter", width: 130, headerClass: getHeaderClass, valueGetter: (params) => params.data?.address1 || "-" },
    { field: "address2", headerName: "Address 2", filter: "agTextColumnFilter", width: 130, headerClass: getHeaderClass, valueGetter: (params) => params.data?.address2 || "-" },
    { field: "city", headerName: "City", filter: "agTextColumnFilter", width: 110, headerClass: getHeaderClass, valueGetter: (params) => params.data?.city || "-" },
    { field: "pincode", headerName: "Pincode", filter: "agTextColumnFilter", width: 100, headerClass: getHeaderClass, valueGetter: (params) => params.data?.pincode || "-" },
    { field: "mobile1", headerName: "Mobile1", filter: "agTextColumnFilter", width: 120, headerClass: getHeaderClass, valueGetter: (params) => params.data?.mobile1 || "-" },
    { field: "bookNo", headerName: "Book No", filter: "agTextColumnFilter", width: 100, headerClass: getHeaderClass, valueGetter: (params) => params.data?.bookNo || "-" },
    { field: "receiptNo", headerName: "Receipt No", filter: "agTextColumnFilter", width: 110, headerClass: getHeaderClass, valueGetter: (params) => params.data?.receiptNo || "-" },
  ];

  return (
    <div className="ag-theme-alpine" style={{ width: "100%" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "10px",
        }}
      >
        <DownloadButton data={data} type={type} />
      </div>
      <AgGridReact
        ref={gridRef}
        onGridReady={onGridReady}
        rowData={data ?? []}
        columnDefs={columnDefs}
        domLayout="autoHeight"
        pagination={true}
        paginationPageSize={10}
        paginationPageSizeSelector={[10, 20, 50]}
      />
    </div>
  );
};

export default PanCardReportPage;
